export default "__VITE_ASSET__Bi60Wk8n__"